import { FETCH_USER_PRODUCT_CATEGORY_LIST } from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const userProductCategoryListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_PRODUCT_CATEGORY_LIST:
      return { list: action.payload, others: action.others };
    default:
      return state;
  }
};

export default userProductCategoryListReducer;
